import { useAuth as useAuthContext } from '../context/AuthContext';

/**
 * Hook personnalisé pour gérer l'authentification
 * Wrapper autour du contexte AuthContext pour une utilisation simplifiée
 *
 * @returns {Object} Objet contenant l'état et les méthodes d'authentification
 * @property {Object|null} user - Utilisateur connecté ou null
 * @property {Function} login - Fonction de connexion (email, password)
 * @property {Function} logout - Fonction de déconnexion
 * @property {boolean} isAuthenticated - True si l'utilisateur est connecté
 * @property {boolean} loading - True pendant le chargement
 * @property {string|null} error - Message d'erreur ou null
 */
const useAuth = () => {
  const context = useAuthContext();

  return {
    user: context.user,
    login: context.login,
    logout: context.logout,
    updateUser: context.updateUser,
    isAuthenticated: context.isAuthenticated,
    loading: context.loading,
    error: context.error,
  };
};

export default useAuth;
